module.exports = __webpack_public_path__ + "img/company.0eef2c49.png";